export default "__VITE_ASSET__DKt6d7BR__"